import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CheckoutDraftType, CheckoutRecipientDataType } from 'src/types/checkout/CheckoutData';
import { DeliveryItemType } from 'src/types/delivery/delivery';
import { RootState } from '../store';

const initialState: CheckoutDraftType = {
    recipient: null,
    delivery: null,
};

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        setCheckoutRecipient: (state, { payload }: PayloadAction<CheckoutRecipientDataType>) => {
            state.recipient = payload;
        },
        setCheckoutDelivery: (state, { payload }: PayloadAction<DeliveryItemType | null>) => {
            state.delivery = payload;
        },
        resetCheckout: () => initialState,
    },
});

export const { setCheckoutRecipient, setCheckoutDelivery, resetCheckout } = checkoutSlice.actions;
export default checkoutSlice.reducer;

export const checkoutSelector = (state: RootState) => state.checkout;
